import { render, staticRenderFns } from "./ContactUsInfoComponent.vue?vue&type=template&id=177ff844"
import script from "./ContactUsInfoComponent.vue?vue&type=script&lang=js"
export * from "./ContactUsInfoComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports